import React, { Component } from "react";
import { BigCalendarEvent } from "./GoogleCalendarImporter";
import moment from "moment";
import { CALENDARS } from "./CALENDARS";
import Popover from "react-popover";
import { EventWrapperProps } from "react-big-calendar";

interface TooltipOnHoverEventWrapperProps {
  event?: BigCalendarEvent;
}

const schoolName = (slug: string) => {
  const school = CALENDARS.find(x => x.slug === slug);
  return school ? school.title : "";
};

const BigEventPopover = (props: { event: BigCalendarEvent }) => {
  const startMoment = moment(props.event.start);
  const endMoment = moment(props.event.end);

  const isSingleDay = endMoment
      .subtract(1, "day")
      .format("YYYYMMDD") === startMoment.format("YYYYMMDD");

  return (
    <div className={`BigEventPopover bep-popover-${props.event.resource.id}`}>
      <div className="bep-school">{schoolName(props.event.resource.id)}</div>
      <div className="bep-title">{props.event.title}</div>
      {props.event.allDay ? (
         isSingleDay ? (
          <div className="bep-all-day">All Day</div>
        ) : (
          <div className="bep-multi-day">
            {startMoment.format("MMMM Do")} -{" "}
            {endMoment.format("MMMM Do")}
          </div>
        )
      ) : (
        <div className="bep-event-date">
          {startMoment.format("MMMM Do LT")} -{" "}
          {endMoment.format("LT")}
        </div>
      )}
      <div className="bep-event-description">{props.event.description}</div>
    </div>
  );
};

export class TooltipOnHoverEventWrapper extends Component<
  TooltipOnHoverEventWrapperProps & EventWrapperProps,
  { isOpen: boolean }
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  open() {
    this.setState({ isOpen: true });
  }

  close() {
    this.setState({ isOpen: false });
  }

  render() {
    return (
      <div onMouseEnter={() => this.open()} onMouseLeave={() => this.close()}>
        {this.props.event && (
          <Popover
            body={<BigEventPopover event={this.props.event} />}
            isOpen={this.state.isOpen}
            preferPlace={"right"}
            onOuterAction={() => this.close()}
            enterExitTransitionDurationMs={200}
          >
            {this.props.children}
          </Popover>
        )}
      </div>
    );
  }
}
